function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSiteCoreAquatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 19.84375 19.84375",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      display: "inline"
    },
    transform: "translate(0,-6.6145833)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578703,
      strokeOpacity: 1
    },
    id: "rect4518-85",
    width: 19.84375,
    height: 19.84375,
    x: 0,
    y: 6.6145835
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#2e4762",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834875,
      strokeOpacity: 1
    },
    id: "rect4518-8-4",
    width: 17.197916,
    height: 17.197916,
    x: 1.3229166,
    y: 7.9375005
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.24736783,
      strokeOpacity: 1
    },
    d: "m 12.898437,17.357333 c 0,1.738526 -1.332654,3.147875 -2.976562,3.147875 -1.6439077,0 -2.9765626,-1.409349 -2.9765626,-3.147875 0,-1.738526 2.0919796,-5.781812 2.9765626,-5.781812 0.884583,0 2.976562,4.043286 2.976562,5.781812 z",
    id: "path4678-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiteCoreAquatic);
export default __webpack_public_path__ + "static/media/icon-site-core-aquatic.cb82eabc661bfef5151033ae1aeeb82d.svg";
export { ForwardRef as ReactComponent };